import React from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

import { openSupportChat } from '../../util/open-support-chat'
import { IVeeMessageItem } from './types'

// The backend prompt tells Vee to write the live chat as this link (leave-assistant system-prompt.ts).
const OPEN_SUPPORT_CHAT_HREF = '#open-support-chat'

const handleSupportChatClick = (event: React.MouseEvent<HTMLAnchorElement>): void => {
  event.preventDefault()
  openSupportChat()
}

interface IVeeMessageProps {
  message: IVeeMessageItem
}

export const VeeMessage: React.FC<IVeeMessageProps> = React.memo(({ message }) => {
  if (message.role === 'user') {
    return (
      <div className="vee-message vee-message-user">
        <div className="vee-message-bubble">{message.content}</div>
      </div>
    )
  }

  return (
    <div className="vee-message vee-message-assistant">
      {/* No images: an auto-fetched <img> URL is a data-exfiltration channel for injected model output. */}
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        skipHtml
        disallowedElements={['img']}
        unwrapDisallowed
        components={{
          a: ({ children, href }) =>
            href === OPEN_SUPPORT_CHAT_HREF ? (
              <a href={href} onClick={handleSupportChatClick}>
                {children}
              </a>
            ) : (
              <a href={href} target="_blank" rel="noopener noreferrer">
                {children}
              </a>
            ),
        }}
      >
        {message.content || ''}
      </ReactMarkdown>
    </div>
  )
})

VeeMessage.displayName = 'VeeMessage'
